export default __webpack_public_path__ + "static/media/bidBanner.png?.b32d7f1d";